import React, { Component, useContext, useEffect, useState } from 'react'
import OurTickets from './OurTickets'

const Dashboard = () => {

    return (
        <>
        
            <OurTickets />
        </>
    )
}

export default Dashboard

